// Tokens visuels des chips feedback (tons Tailwind par type/statut/priorite).
// Module .ts pur — pas de composants React (Fast Refresh inutile ici).
import { GS_COMPONENTS } from '@gs/ui';
import type { FeedbackPriority, FeedbackStatus, FeedbackType } from '../schemas';

export const TYPE_CHIP: Record<FeedbackType, string> = {
  BUG: 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300',
  FEATURE: 'bg-violet-50 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300',
  IMPROVEMENT: 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300',
  GENERAL: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
};

export const STATUS_CHIP: Record<FeedbackStatus, string> = {
  NEW: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
  IN_PROGRESS: 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300',
  WAITING: 'bg-sky-50 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300',
  TO_VALIDATE: 'bg-violet-50 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300',
  RESOLVED: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300',
  CANCELLED: 'bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300',
  ARCHIVED: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
};

export const PRIORITY_CHIP: Record<FeedbackPriority, string> = {
  LOW: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
  MEDIUM: 'bg-sky-50 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300',
  HIGH: 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300',
  CRITICAL: 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300',
};

export const CHIP_BASE =
  'inline-flex items-center rounded-md px-1.5 py-0.5 text-chip font-semibold';

/** Chip provenance compagnie (lecteur corporate, CHORE-FIX-B1 P2) — neutre. */
export const COMPANY_CHIP = 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300';

/** Chip app d'origine (originBcKey) — neutre, distinct du type/statut. */
export const ORIGIN_APP_CHIP = COMPANY_CHIP;

/** Badge staff inline — tonal slate (pas bg-slate-800 action). */
export const STAFF_BADGE_CHIP =
  'bg-slate-200 text-slate-800 dark:bg-slate-600 dark:text-slate-100';

/** Réexports @gs/ui — aucune constante de design locale (MASTER-FEEDBACK-ALIGN-UG 2026-06-26). */
export const BTN_PRIMARY = GS_COMPONENTS.btnAction;
export const BTN_SECONDARY = GS_COMPONENTS.btnSecondary;
export const BTN_DANGER_OUTLINE = GS_COMPONENTS.btnDangerOutline;
export const INPUT_BASE = GS_COMPONENTS.input;
